import React from 'react';
import { GetStaticProps } from 'next';
import { withGlobalProvider } from 'providers/globalProvider';
import { storeWrapper } from '@state/store';
import { initializeApp } from '@state/initializeApp';
import SitemapDestinationPageLayout, {
  SitemapDestinationPageLayoutProps
} from '@layout/SitemapPageLayout/SitemapDestinationPageLayout';
import { Page } from '@model/common';
import { ContentApi } from '@model/iceberg/service/content';
import { Revalidate } from '@model/config/revalidate';

const SitemapDestinationPage = (props: SitemapDestinationPageLayoutProps) => {
  return <SitemapDestinationPageLayout {...props} />;
};

export const getStaticProps: GetStaticProps = storeWrapper.getStaticProps(
  (store) =>
    async ({ params: { destination: query } }: any) => {
      const props = await initializeApp(store, async () => {
        const path = query.join('/');
        const destination = await new ContentApi().getDestination(path);

        return {
          path,
          destination: destination[0] || null
        };
      });
      return {
        ...props,
        revalidate: Revalidate.HALF_HOUR
      };
    }
);

export async function getStaticPaths() {
  const destinations = await new ContentApi().getDestinations();
  const paths: Array<string> = destinations.map(({ path }) => Page.SITEMAP.concat('/').concat(path));

  return { paths, fallback: false };
}

export default withGlobalProvider(SitemapDestinationPage);
